module.exports = __webpack_public_path__ + "img/service.c41f384c.svg";